/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GATrackingEventType {
  AddShippingInfo = 'add_shipping_info',
  AddPaymentInfo = 'add_payment_info',
  AddToCart = 'Add to Cart',
  AlternativeProductClick = 'Click on Alternative Products',
  AlternativeProductsShow = 'Show Alternative Products',
  AssistedSales = 'Assisted Sales',
  Authorization = 'Authorization',
  AutoCorrectedSearch = 'Auto-Corrected Search',
  BannerClickExperiment = 'Banner Click Experiment',
  BannerClick = 'Promo Click',
  ButtonClick = 'Button Click',
  BreadcrumbClick = 'Breadcrumb Click',
  CarouselButton = 'carouselButton',
  CarouselClick = 'carouselClick',
  CartUpdate = 'Cart Update',
  CategoryImageClick = 'Category Image Click',
  CategoryMenuClick = 'Category Menu Click',
  CategoryPageZeroResult = 'Category page Zero Result',
  Checkout = 'Checkout',
  CheckoutErrors = 'Checkout Errors',
  CheckoutStepNavigationClick = 'Checkout Step Navigation click',
  CheckoutStepper = 'Checkout Stepper',
  CookieConsent = 'Consent',
  CreateAccount = 'Create Account',
  CreateAccountExperiment = '',
  EditorialLinkNavigationClick = 'Editorial Links Navigation',
  FilteredSearch = 'Filtered Search',
  FilteredCategoryPage = 'Filtered Category Page',
  FilterAreaInteraction = 'Filter Area Interaction',
  CustomLinkedGrid = 'Custom Linked Grid',
  FooterNavigationClick = 'Footer Navigation Click',
  GlobalFooterClick = 'Global Footer Click',
  HomepageScrolling = 'Home Page Scrolling',
  HomepageView = 'Homepage View',
  IdamSignUp = 'IDAM Signup',
  ListView = 'List View',
  LogoutClick = 'Logout Click',
  Navigation = 'Navigation',
  NavigationBarClick = 'Navigation Bar Click',
  NavigationUserAccountMenuClick = 'Navigation User Account Menu Click',
  Notification = 'Notification',
  Optimize = 'Optimize',
  OrdersHistoryHeaderLinkClick = 'se_order_history_header_link_clicked',
  PaymentFailure = 'Payment Failure',
  PdpDescriptionInteraction = 'PDP description interaction',
  PdpImageInteraction = 'PDP image interaction',
  PdpOtherOffersInteraction = 'Offer picker',
  PdpScrolling = 'PDP Scrolling',
  PLPCategoryFilterClick = 'Category Filter on PLP',
  PLPCategoryNavigation = 'PLP Category Navigation',
  PLPCategoryNavigationExpanded = 'PLP Category Navigation Expanded',
  PLPPaginationClick = 'PLP Pagination Click',
  PLPShowMoreProductsClick = 'PLP Click Show 20 more products',
  PLPScrolling = 'PLP scrolling',
  ProductClick = 'Product Click',
  ProductDetailsView = 'Product Details View',
  PriceTypePopup = 'Price type popup accepted',
  PriceTypeToggler = 'Price Toggler',
  ProductsListSorting = 'PLP sorting dropdown',
  PromoImageLinkClick = 'Sales Navigation Banner',
  PromoView = 'Content Products View',
  Purchase = 'Purchase',
  PurchaseGA4 = 'purchase_ga4',
  QuantityPickerInteraction = 'Change product quantity',
  RemoveFromCart = 'Remove from Cart',
  ReviewOrderInfo = 'review_order_info',
  RemoveFilteredSearch = 'Filtered Search removed',
  RemoveFilteredCategoryPage = 'Filtered Category page removed',
  Search = 'Search',
  CategoryPage = 'Category page',
  CategoryPageViewed = 'Category Page View',
  SearchInteraction = 'Using Search Bar',
  SearchSuggestion = 'Search Suggestion',
  SearchZeroResult = 'Search Zero Result',
  SeoFaqToggle = 'Content FAQ',
  SimilarProductClick = 'Similar Product Click',
  SimilarProductsView = 'Similar Products View',
  TopNavigationClick = 'Top Navigation Click',
  VolumePriceSelected = 'Volume pricing click',
  VolumePriceTableClick = 'volume pricing table click',
  PLPSeoText = 'SEO text on PLP shown',
  CartLinkClick = 'Cart link click',
  PLPPriceFilterInteraction = 'Price Filter interaction',
  PDPRegisterAsBusiness = 'PDP register as a business interaction',
  PageView = 'Page View',
  LoadBeeButtonView = 'Loadbee button View',
  ProceedToCheckout = 'proceedToCheckout',
  RegistrationTypeClicked = 'Registration type Clicked',
  RegisterWithEmailButtonClicked = 'Register With Email Button Clicked',
  OfferPriceSyncIssue = 'Offer Price Sync Issue',
  NewsletterSubscription = 'Newsletter subscription',
  HubPageCardClick = 'Hub Page Card Click',
  FeatureFlag = 'feature_flag',
  PdpOfferMismatch = 'PDP Marketing Feed Offer Mismatch',
  FlixMediaContentView = 'Flix Media Content View',
  FlixMediaContentScrolling = 'Flixmedia content scrolled',
  FlixMediaContentFailed = 'Content load failed',
  FlixMediaFailed = 'Script load failed',
  PDPFoodCategoryLink = 'Food Free Shipping Click',
  OptimizelyActivateExperiment = 'activate_experiment',
  OrderHistorySideMenu = 'interaction',
  PdpWeeMoreDetailsInteraction = 'weee_details_click',
  ContentCardClick = 'Content Cards Click',
  ViewItemList = 'view_item_list',
  ViewPromotion = 'view_promotion',
  SelectItem = 'select_item',
  SelectPromotion = 'select_promotion',
  PromotionClick = 'Content Products Click',
  ViewCart = 'view_cart',
  RemoveItemFromCart = 'remove_from_cart',
  BeginCheckout = 'begin_checkout',
  ViewItem = 'view_item',
  AddToCartGa4 = 'add_to_cart',
  ViewRecommendation = 'Products recommendation View',
  SelectRecommendation = 'Products recommendation Select',
  InstallationServices = 'Service Installation Checkbox Interaction',
  InstallationServicesDetails = 'Service Installation Details click',
  InstallationServicesDetailsLinks = 'Service Installation Information Link Click',
  ShowTooltipValueAddedService = 'Cart tooltip VAS interaction',
  HeroBannerClick = 'Content Hero Banner',
  CallbackClick = 'Callback Button Click',
  productCarouselTeaserClick = 'clickProductCarouselTeaser',
  InvalidOfferForRegion = 'InvalidOfferForRegion',
  ChangeDeliveryAddress = 'ChangeDeliveryAddress',
  BackToCart = 'BackToCart',
  ZRPOutOfScopeBannerVisibility = 'Out of scope banner on ZRP is',
  ZRPOutOfScopeCategoryGrid = 'Out of scope Category Grid on ZRP is',
  ZRPPopularCategories = 'zero results page|popular category is',
  ZRPOtherBuckets = 'zero results page|other buckets is',
  ZRPCategoryClicked = 'zero results page|popular category clicked',
  SE_PLP_CATEGORY_NAVIGATION_VIEWED = 'se_plp_category_navigation_viewed',
  SE_PLP_CATEGORY_NAVIGATION_EXPANDED = 'se_plp_category_navigation_expanded',
  SE_PLP_CATEGORY_NAVIGATION_COLLAPSED = 'se_plp_category_navigation_collapsed',
  SE_PLP_CATEGORY_NAVIGATION = 'se_plp_category_navigation',
  SE_BENEFITS_VIEWED = 'se_benefits_viewed',
  SE_BEST_SELLING_BRANDS_VIEWED = 'se_best_selling_brands_viewed',
  SE_BEST_SELLING_BRANDS_CLICKED = 'se_best_selling_brands_clicked',
  NEWSLETTER_VIEWED = 'se_newsletter_viewed',
  NEWSLETTER_SUSCRIPTION = 'se_newsletter_subscription',
  SE_SEE_OFFERS = 'se_see_offers',
  SE_HEADLINE_BANNER_VIEWED = 'se_headline_banner_viewed',
  GenesysEnabled = 'genesys_enabled',
  SE_POPULAR_LINKS_VIEWED = 'se_popular_categories_viewed',
  SE_RELATED_CATEGORIES_VIEWED = 'se_related_categories_viewed',
  SE_POPULAR_LINKS_CLICKED = 'se_popular_categories_clicked',
  SE_RELATED_CATEGORIES_CLICKED = 'se_related_categories_clicked',
  SE_POPULAR_LINKS_SHOW_MORE = 'se_popular_categories_show_more',
  SE_RELATED_CATEGORIES_SCROLL = 'se_related_categories_scroll',
  SE_POPULAR_LINKS_SHOW_LESS = 'se_popular_categories_show_less',
  SE_LOCATION_TOGGLER = 'se_location_toggler',
  SE_HORIZONTAL_SCROLL = 'se_horizontal_scroll',
  SE_SPONSORING_BANNER_HOVERED = 'se_banner_hovered',
  SE_SPONSORING_BANNER_CLICKED = 'se_banner_clicked',
  SE_HOVER_IMAGE_SEARCH = 'se_hover_image_search',
  SE_IMAGE_SEARCH_LOGO_CLICKED = 'se_image_search_logo_clicked',
}
